import React from 'react';

const FieldMessage = ({ color, message, id }) => (
    <div style={{ color }} id={id}>
      <small>{message}</small>
    </div>
  )

export default FieldMessage


// WEBPACK FOOTER //
// ./src/components/common/FieldMessage.js